import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, createInvalidWarehouseSection, PreventionInvalidityCode, PreventativeAutocompleteType} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productWarehouseAssignment,
    sections: [
        createInvalidPartSection('partNumber'),
        createInvalidWarehouseSection('warehouseCode'),
        {
            sectionKey: 'missingProductWarehouseAssignmentFields',
            sectionTitle: 'Missing Required Fields',
            invalidityCode: PreventionInvalidityCode.MISSING_REQUIRED_FIELDS,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: PreventativeAutocompleteType.PART,
                    extractValue: (o) => (typeof o === 'string' ? o : o?.partNo ?? null),
                    modifyRow: (row, val) => ({...row, partNumber: val}),
                    autocompleteProps: {
                        placeholder: 'Search for part...',
                        getOptionLabel: (o) => o?.partNo ?? '',
                        isOptionEqualToValue: (o, v) => o?.partNo === v?.partNo,
                    },
                },
                {
                    key: 'warehouseCode',
                    label: 'Warehouse',
                    type: PreventativeAutocompleteType.WAREHOUSE,
                    extractValue: (o) => (typeof o === 'string' ? o : o?.code ?? null),
                    modifyRow: (row, val) => ({...row, warehouseCode: val}),
                    autocompleteProps: {
                        placeholder: 'Search for warehouse...',
                        getOptionLabel: (o) => (o?.name ? `${o.name} (${o.code})` : o?.code ?? ''),
                        isOptionEqualToValue: (o, v) => o?.code === v?.code,
                    },
                },
            ],
        },
    ],
};
